/**
 * Prefill (Phase 4 data reuse) — remember State / ZIP / relationship once,
 * reuse everywhere (GUIDE provider finder, local resources, screeners).
 * Anonymous visitors get localStorage; signed-in caregivers also sync to
 * the server so it follows them across devices.
 */
import { api, getToken } from "./api";

const KEY = "ml_prefill";

export function getLocalPrefill() {
    try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch { return {}; }
}

export function saveLocalPrefill(fields) {
    try { localStorage.setItem(KEY, JSON.stringify({ ...getLocalPrefill(), ...fields })); } catch { /* private mode */ }
}

/** Server values win over local (they follow the account across devices). */
export async function loadPrefill() {
    const local = getLocalPrefill();
    if (!getToken()) return local;
    try {
        const r = await api.get("/me/prefill");
        const server = Object.fromEntries(Object.entries(r.data || {}).filter(([, v]) => v));
        return { ...local, ...server };
    } catch {
        return local;
    }
}

export function savePrefill(fields) {
    saveLocalPrefill(fields);
    if (getToken()) api.post("/me/prefill", fields).catch(() => { /* non-blocking */ });
}
